export enum BaseData {
  OperationTeam = "OperationTeam",
  ClientType = "ClientTypes",
  Producers = "Producers",
  ProducersClientsCommission = "ProducersClientsCommission",
  ProducersSalesCommission = "ProducersSalesCommission",
  ProducersProductionCommission = "ProducersProductionCommission",
  ProducersClients = "ProducersClients",
  ProducersProduction = "ProducersProduction",
  ProducersSales = "ProducersSales",
  BranchClients = "BranchClients",
  BranchProduction = "BranchProduction",
  BranchSales = "BranchSales",
  BranchCustomerService = "BranchCustomerService",
  BranchClaim = "BranchClaim",
  SectorTypes = "SectorTypes",
  RelationshipStatus = "RelationshipStatus",
  BusinessType = "BusinessType",
  Channels = "Channels",
  Interface = "Interface",
  ScreeningResult = "ScreeningResult",
  Locations = "Locations",
  InvoiceNote = "InvoiceNote",
  Nationalities = "Nationalities",
  SourceofIncome = "SourceofIncome",
  RegistrationStatus = "RegistrationStatus",
  BusinessActivities = "BusinessActivities",
  MarketSegment = "MarketSegment",
  Premium = "Premium",
  Positions = "Positions",
  Branch = "Branch",
  LineOfBusiness = "LineOfBusiness",
  ContactLineOfBusiness = "ContactLineOfBusiness",
  ContactDepartment = "ContactDepartment",
  Banks = "Banks",
  CommericalNo = "CommericalNo",
  GroupsList = "GroupsList",
  ClientStatus = "ClientStatus",
  InsurClasses = "InsurClasses",
  IndustryCategories = "IndustryCategories",
  AllUsers = "AllUsers",
  SlipStage = "SlipStage",
  SalesleadStage = "SalesleadStage",
  SalesleadOpportunityStatus = "SalesleadOpportunityStatus",
  SalesleadPlacementStatus = "SalesleadPlacementStatus",
  SalesLeadClientsStatus = "SalesLeadClientsStatus",
  SalesLeadLeadStatus = "SalesLeadLeadStatus",
  SalesleadProspectStatus = "SalesleadProspectStatus",
  SalesleadLostReason = "SalesleadLostReason",
  SalesLeadAllStatus = "SalesLeadAllStatus",
  PolicyStatus = "PolicyStatus",
  PolicyEndorsTypes = "PolicyEndorsTypes",
  PolicySearchEndorType = "PolicySearchEndorType",
  CusSerEndorsTypes = "CusSerEndorsTypes",
  ClientsList = "ClientsList",
  InsuranceCompanies = "InsuranceCompanies",
  CServiceStatus = "CServiceStatus",
  PendingReason = "PendingReason",
  TypeOfCustomerServices = "TypeOfCustomerServices",
  AllClients = "AllClients",
  InsuranceCompanyName = "InsuranceCompanyName",
  InsuranceBrokersList = "InsuranceBrokersList",
  LogType = "LogType",
  ProductionFieldList = "ProductionFieldList",
  ProductionOperatordList = "ProductionOperatordList",
  VATPercentage = "VATPercentage",
  ClaimStatus = "ClaimStatus",
  JobTitleOfUsers = "JobTitleOfUsers",
  StatusOfUsers = "StatusOfUsers",
  ProducersList = "ProducersList",
  UserSecurityRoles = "UserSecurityRoles",
  Currencies = "Currencies",
  RejectionReasons = "RejectionReasons",
  ProspectsReportsTypes = "ProspectsReportsTypes",
  ClaimCaseTypes = "ClaimCaseTypes",
  MotorClaimTypes = "MotorClaimTypes",
  TypesOfRepair = "TypesOfRepair",
  Surveyor = "Surveyor",
  BeneficiaryTypes = "BeneficiaryTypes",
  PlateLetters = "PlateLetters",
  Hospitals = "Hospitals",
  CarsModels = "CarsModels",
  Cities = "Cities",
  ProductionReportType = "ProductionReportType",
  ProductionReportBasedOn = "ProductionReportBasedOn",
  ProductionReportCaptive = "ProductionReportCaptive",
  ProductionReportStatus = "ProductionReportStatus",
  RenewalNoticeReportStatus = "RenewalNoticeReportStatus",
  CSReportType = "CSReportType",
  CSReportStatus = "CSReportStatus",
  ClaimsReportType = "ClaimsReportType",
  VehicleCarsMake = "VehicleCarsMake",
  Regions = "Regions",
  TypeClaimsRejectionReason = "TypeClaimsRejectionReason",
  GetPolicyTypeIssue = "GetPolicyTypeIssue",
  CategoryOfDefaultEmail = "CategoryOfDefaultEmail",
  TasksTypes = "TasksTypes",
  IBSModules = "IBSModules",
  GetStatusClientsPolicies = "GetStatusClientsPolicies",
  typeOfLoans = "typeOfLoans",
  BloodType = "TypeofBlood",
  GetDistinctStaffProfilesNames = "GetDistinctStaffProfilesNames",
  GetDistinctVacationTypes = "GetDistinctVacationTypes",
  GetItemsRequestTypes = "GetItemsRequestTypes",
  GetDepartments = "GetDepartments",
  ExcuseType = "ExcuseType",
  GetOnlinePortalStatus = "GetOnlinePortalStatus",
  SlipsStatus = "SlipsStatus",
  ProspectsLossReasons = "ProspectsLossReasons",
  VoucherTypes = "VouchersTypes",
  // GetAllDocumentsProdction = "GetAllDocumentsProdction",
  DeliveryStatus = "DeliveryStatus",
  ComplaintModeOfReceipt ="ComplaintModeOfReceipt",
  ComplaintImportance = "ComplaintImportance" ,
  ComplaintCategory = "ComplaintCategory",
  ComplaintDepartment = "ComplaintDepartment",
  ComplaintType="ComplaintType",
  ComplainantType="ComplainantType",
  ComplainStatus ="ComplainStatus",
}

export interface IBaseMasterTable {
  [BaseData.ClientType]?: Caching<IGenericResponseType[]>;
  [BaseData.Producers]?: Caching<IGenericResponseType[]>;
  [BaseData.SectorTypes]?: Caching<IGenericResponseType[]>;
  [BaseData.InvoiceNote]?: Caching<IGenericResponseType[]>;
  [BaseData.RelationshipStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.BusinessType]?: Caching<IGenericResponseType[]>;
  [BaseData.Channels]?: Caching<IGenericResponseType[]>;
  [BaseData.Interface]?: Caching<IGenericResponseType[]>;
  [BaseData.ScreeningResult]?: Caching<IGenericResponseType[]>;
  [BaseData.Locations]?: Caching<IGenericResponseType[]>;
  [BaseData.Nationalities]?: Caching<INationality[]>;
  [BaseData.SourceofIncome]?: Caching<IGenericResponseType[]>;
  [BaseData.RegistrationStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.BusinessActivities]?: Caching<IBusinessActivity[]>;
  [BaseData.MarketSegment]?: Caching<IGenericResponseType[]>;
  [BaseData.Premium]?: Caching<IGenericResponseType[]>;
  [BaseData.Positions]?: Caching<IPositions[]>;
  [BaseData.Branch]?: Caching<IGenericResponseType[]>;
  [BaseData.ContactLineOfBusiness]?: Caching<IGenericResponseType[]>;
  [BaseData.ContactDepartment]?: Caching<IGenericResponseType[]>;
  [BaseData.Banks]?: Caching<IBanks[]>;
  [BaseData.CommericalNo]?: Caching<IGenericResponseType[]>;
  [BaseData.GroupsList]?: Caching<IGenericResponseType[]>;
  [BaseData.ClientStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.CServiceStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.PendingReason]?: Caching<IGenericResponseType[]>;
  [BaseData.AllUsers]?: Caching<IGenericResponseType[]>;
  [BaseData.TypeOfCustomerServices]?: Caching<IGenericResponseType[]>;
  [BaseData.SalesleadStage]?: Caching<IGenericResponseType[]>;
  [BaseData.SlipStage]?: Caching<IGenericResponseType[]>;
  [BaseData.SalesleadOpportunityStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.SalesleadPlacementStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.SalesleadLostReason]?: Caching<IGenericResponseType[]>;
  [BaseData.SalesLeadAllStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.PolicyEndorsTypes]?: Caching<IGenericResponseType[]>;
  [BaseData.CusSerEndorsTypes]?: Caching<IGenericResponseType[]>;
  [BaseData.PolicySearchEndorType]?: Caching<IGenericResponseType[]>;
  [BaseData.ClientsList]?: Caching<IGenericResponseType[]>;
  [BaseData.InsuranceCompanies]?: Caching<IGenericResponseType[]>;
  [BaseData.PolicyStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.AllClients]?: Caching<IGenericResponseType[]>;
  [BaseData.InsurClasses]?: Caching<IGenericResponseType[]>;
  [BaseData.IndustryCategories]?: Caching<IGenericResponseType[]>;
  [BaseData.InsuranceCompanyName]?: Caching<IGenericResponseType[]>;
  [BaseData.InsuranceBrokersList]?: Caching<IGenericResponseType[]>;
  [BaseData.LogType]?: Caching<IGenericResponseType[]>;
  [BaseData.ProductionFieldList]?: Caching<IGenericResponseType[]>;
  [BaseData.ProductionOperatordList]?: Caching<IGenericResponseType[]>;
  [BaseData.VATPercentage]?: Caching<IGenericResponseType[]>;
  [BaseData.ClaimStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.JobTitleOfUsers]?: Caching<IGenericResponseType[]>;
  [BaseData.StatusOfUsers]?: Caching<IGenericResponseType[]>;
  [BaseData.ProducersList]?: Caching<IGenericResponseType[]>;
  [BaseData.UserSecurityRoles]?: Caching<IGenericResponseType[]>;
  [BaseData.Currencies]?: IGenericResponseType[];
  [BaseData.RejectionReasons]?: Caching<IGenericResponseType[]>;
  [BaseData.ProspectsReportsTypes]?: Caching<IGenericResponseType[]>;
  [BaseData.ClaimCaseTypes]?: Caching<IGenericResponseType[]>;
  [BaseData.MotorClaimTypes]?: Caching<IGenericResponseType[]>;
  [BaseData.TypesOfRepair]?: Caching<IGenericResponseType[]>;
  [BaseData.Surveyor]?: Caching<IGenericResponseType[]>;
  [BaseData.BeneficiaryTypes]?: Caching<IGenericResponseType[]>;
  [BaseData.PlateLetters]?: Caching<IGenericResponseType[]>;
  [BaseData.Hospitals]?: Caching<IGenericResponseType[]>;
  [BaseData.CarsModels]?: Caching<IGenericResponseType[]>;
  [BaseData.Cities]?: Caching<IGenericResponseType[]>;
  [BaseData.ProductionReportType]?: Caching<IGenericResponseType[]>;
  [BaseData.ProductionReportBasedOn]?: Caching<IGenericResponseType[]>;
  [BaseData.ProductionReportCaptive]?: Caching<IGenericResponseType[]>;
  [BaseData.ProductionReportStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.RenewalNoticeReportStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.CSReportType]?: Caching<IGenericResponseType[]>;
  [BaseData.CSReportStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.ClaimsReportType]?: Caching<IGenericResponseType[]>;
  [BaseData.VehicleCarsMake]?: Caching<IGenericResponseType[]>;
  [BaseData.Regions]?: Caching<IGenericResponseType[]>;
  [BaseData.TypeClaimsRejectionReason]?: Caching<IGenericResponseType[]>;
  [BaseData.GetPolicyTypeIssue]?: Caching<IGenericResponseType[]>;
  [BaseData.CategoryOfDefaultEmail]?: Caching<IGenericResponseType[]>;
  [BaseData.TasksTypes]?: Caching<IGenericResponseType[]>;
  [BaseData.IBSModules]?: Caching<IGenericResponseType[]>;
  [BaseData.GetStatusClientsPolicies]?: Caching<IGenericResponseType[]>;
  [BaseData.typeOfLoans]?: Caching<IGenericResponseType[]>;
  [BaseData.BloodType]?: Caching<IGenericResponseType[]>;
  [BaseData.GetDistinctVacationTypes]?: Caching<IGenericResponseType[]>;
  [BaseData.GetDistinctStaffProfilesNames]?: Caching<IGenericResponseType[]>;
  [BaseData.GetItemsRequestTypes]?: Caching<IGenericResponseType[]>;
  [BaseData.GetDepartments]?: Caching<IGenericResponseType[]>;
  [BaseData.ExcuseType]?: Caching<IGenericResponseType[]>;
  [BaseData.GetOnlinePortalStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.SlipsStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.ProspectsLossReasons]?: Caching<IGenericResponseType[]>;
  [BaseData.VoucherTypes]?: Caching<IGenericResponseType[]>;
  // [BaseData.GetAllDocumentsProdction]?: Caching<IGenericResponseType[]>;
  [BaseData.DeliveryStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.ComplaintDepartment]?: Caching<IGenericResponseType[]>;
  [BaseData.ComplaintType]?: Caching<IGenericResponseType[]>;
  [BaseData.ComplainantType]?: Caching<IGenericResponseType[]>;
  [BaseData.ComplainStatus]?: Caching<IGenericResponseType[]>;
  [BaseData.ComplaintCategory]?: Caching<IGenericResponseType[]>;
  [BaseData.ComplaintImportance]?: Caching<IGenericResponseType[]>;
  [BaseData.ComplaintModeOfReceipt]?: Caching<IGenericResponseType[]>;
  [BaseData.ProducersProduction]?: Caching<IGenericResponseType[]>;
  [BaseData.ProducersClientsCommission]?: Caching<IGenericResponseType[]>;
  [BaseData.ProducersSalesCommission]?: Caching<IGenericResponseType[]>;
  [BaseData.ProducersProductionCommission]?: Caching<IGenericResponseType[]>;
  [BaseData.ProducersClients]?: Caching<IGenericResponseType[]>;
  [BaseData.ProducersSales]?: Caching<IGenericResponseType[]>;
  [BaseData.BranchProduction]?: Caching<IGenericResponseType[]>;
  [BaseData.BranchClients]?: Caching<IGenericResponseType[]>;
  [BaseData.BranchSales]?: Caching<IGenericResponseType[]>;
  [BaseData.BranchCustomerService]?: Caching<IGenericResponseType[]>;
  [BaseData.BranchClaim]?: Caching<IGenericResponseType[]>;
}

export interface Caching<T> {
  cacheable: boolean;
  content: T;
}

export interface IAllClients {
  sNo: number;
  fullName: string;
  producer: string;
  status: string;
}

export interface IGenericResponseType {
  id: number;
  name: string;
}

export interface INationality {
  nationalityEn?: string;
  nationalityAr?: string;
}

export interface IBusinessActivity {
  sNo: number;
  businessActivity: string;
}

export interface IPositions {
  sNo: number;
  position: string;
}
export interface IBanks {
  sNo?: number;
  bankName?: string;
  swift?: string;
}

export interface IClientTypes {
  id: number;
  name: string;
}
